import { useAtomValue, useAtom, useSetAtom } from 'jotai'
import { Moon, PanelLeft, Sun } from 'lucide-react'
import { currentClassroomAtom, currentSessionAtom, isDarkAtom, sidebarOpenAtom } from '../state/store'
import { saveTheme } from '../lib/storage'
import { Tooltip, TooltipTrigger, TooltipContent } from './ui/tooltip'

export function ChatHeader() {
  const currentSession = useAtomValue(currentSessionAtom)
  const currentClassroom = useAtomValue(currentClassroomAtom)
  const [isDark, setIsDark] = useAtom(isDarkAtom)
  const setSidebarOpen = useSetAtom(sidebarOpenAtom)

  const toggleTheme = () => {
    setIsDark((prev) => {
      const next = !prev
      document.documentElement.classList.toggle('dark', next)
      saveTheme(next ? 'dark' : 'light')
      return next
    })
  }

  return (
    <header className="shrink-0 h-12 flex items-center px-3 border-b-2 border-nb-border bg-secondary-bg">
      <div className="flex items-center w-10">
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              className="rounded-base border-2 border-nb-border p-1.5 text-foreground hover:bg-main/20 active:translate-x-boxShadowX active:translate-y-boxShadowY transition-all"
              onClick={() => setSidebarOpen((prev) => !prev)}
            >
              <PanelLeft className="h-5 w-5" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom">Toggle sidebar</TooltipContent>
        </Tooltip>
      </div>

      <div className="flex-1 min-w-0 px-3">
        {currentClassroom ? (
          <div className="min-w-0">
            <div className="truncate font-heading text-sm text-foreground">
              {currentSession ? currentSession.name || 'New chat' : 'Class Home'}
            </div>
            <div className="truncate text-xs text-foreground/50">
              {currentClassroom.title}
            </div>
          </div>
        ) : (
          <div className="font-heading text-sm text-foreground">My Classes</div>
        )}
      </div>

      <div className="flex w-10 justify-end">
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              className="rounded-base border-2 border-nb-border p-1.5 text-foreground transition-all hover:bg-main/20 active:translate-x-boxShadowX active:translate-y-boxShadowY"
              onClick={toggleTheme}
            >
              {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom">{isDark ? 'Light mode' : 'Dark mode'}</TooltipContent>
        </Tooltip>
      </div>
    </header>
  )
}
